// TODO
// eslint-disable-next-line @typescript-eslint/naming-convention
export interface DataProcessingProtocol {
  processResponse(response: any): any;
}
